import { AnyAction, ThunkAction } from "@reduxjs/toolkit";
import { CustomerTypeModel } from "../../models/CustomerTypeModel";
import CustomerTypeService from "../../services/CustomerTypeService";
import CustomerTypeSlice from "../slices/CustomerTypeSlice";
import { RootState } from "../store";

export const CustomerTypeActions = CustomerTypeSlice.actions;
export const fetchCustomerTypes = (): ThunkAction<
  void,
  RootState,
  unknown,
  AnyAction
> => {
  return async (dispatch) => {
    dispatch(CustomerTypeActions.setIsCustomerTypesFetching(true));
    const response: CustomerTypeModel[] =
      await CustomerTypeService.getAllCustomerTypes();
    dispatch(CustomerTypeActions.setCustomerTypes(response));
    dispatch(CustomerTypeActions.setIsCustomerTypesFetching(false));
  };
};
export const fetchParticularCustomerType = (
  CustomerType_id: number
): ThunkAction<void, RootState, unknown, AnyAction> => {
  return async (dispatch, getState) => {
    const response: CustomerTypeModel =
      await CustomerTypeService.getParticularCustomerType(CustomerType_id);
    dispatch(CustomerTypeActions.setParticularCustomerType(response));
  };
};
